// extracted by mini-css-extract-plugin
export default {"container":"Grsh5ETwUyW4unyK1HDx","image":"M43OB4jpmkIuwiYuCsAX","gradientMask":"THSnP3q0IUgrLLAyXgX9","title":"CXsjwF9UQowHuYFtlnHj","accentSpan":"ZiQDojOKMctA5OCEAyPY"};